import MarginEstimasi from "@/components/master/margin_estimasi/MarginEstimasi.vue";
import MarginEstimasiAdd from "@/components/master/margin_estimasi/MarginEstimasiAdd.vue";
import MarginEstimasiEdit from "@/components/master/margin_estimasi/MarginEstimasiEdit.vue";
import MarginEstimasiDetail from "@/components/master/margin_estimasi/MarginEstimasiDetail.vue";

const routesMarginEstimasi = [
  {
    path: "",
    meta: {
      title: "Chain System",
    },
    name: "MarginEstimasi",
    component: MarginEstimasi,
  },
  {
    path: "add",
    meta: {
      title: "Chain System",
    },
    name: "MarginEstimasiAdd",
    component: MarginEstimasiAdd,
  },
  {
    path: "edit/:id",
    meta: {
      title: "Chain System",
    },
    name: "MarginEstimasiEdit",
    component: MarginEstimasiEdit,
  },
  {
    path: "detail/:id",
    meta: {
      title: "Chain System",
    },
    name: "MarginEstimasiDetail",
    component: MarginEstimasiDetail,
  },
];

export default routesMarginEstimasi;
